import BaseIcon from './base-icon';

class XIcon extends BaseIcon {
  renderSVG(): string {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" stroke-width="2" viewBox="0 0 24 24" fill="none">
        <path d="M3 3L21 21" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M21 3L3 21" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    `;
  }
}

customElements.define('x-icon', XIcon);
